import { render, staticRenderFns } from "./AccountSetting.vue?vue&type=template&id=b28a3644"
import script from "./AccountSetting.vue?vue&type=script&lang=js"
export * from "./AccountSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports